import type { ReactNode } from "react";

type BadgeTone = "" | "ok" | "warn" | "bad" | "muted";

export function Badge({
  tone = "",
  children,
}: {
  tone?: BadgeTone;
  children: ReactNode;
}) {
  return <span className={`badge ${tone}`.trim()}>{children}</span>;
}
